import { Checkbox } from '@mui/material'
import useStyles from './useStyles'
import { useEffect, useState } from 'react'

function TableHeader ({ setAllChecked, allChecked, setElementsChecked }) {
  const classes = useStyles()
  const [checked, setChecked] = useState(false)

  const handleChange = (event) => {
    setChecked(event.target.checked)
    setAllChecked(event.target.checked)
    if (!event.target.checked) {
      setElementsChecked([])
    }
  }

  useEffect(() => {
    allChecked ? setChecked(true) : setChecked(false)
  }, [allChecked])

  return (
    <thead className={classes.row}>
      <tr>
        <th className={classes.headCheck}>
          <Checkbox checked={checked} onChange={handleChange} />
        </th>
        <th className={classes.headNameLegal}>Cliente</th>
        <th className={classes.headNameLegal}>Descripción</th>
        {/* <th className={classes.headType}>Asignados</th> */}
        <th className={classes.headNameLegal}>Editor</th>
        <th className={classes.headPeriod}>Período</th>
        <th className={classes.headType}>Vencimiento</th>
        <th className={classes.headType}>Estado DJ</th>
        <th className={classes.headEdit}>Modificación</th>
        <th className={classes.headKebab}></th>
      </tr>
    </thead>
  )
}

export default TableHeader
